<ng-container [formGroup]="form">
  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">

    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {
        <div [formArrayName]="fieldData.name">
          <!--    add multiplicity here-->
        </div>
      } @else {
        <input class="uk-input uk-width-9-10 uk-animation-scale-up" [ngClass]="{'uk-form-danger': checkFormValidity()}"
               [formControlName]="fieldData.name" [id]="inputId" [step]='step'
               placeholder="{{fieldData.form.placeholder}}"
               (input)="updateBitSet(fieldData); unsavedChangesPrompt()"
               (focus)="focus()" (focusout)="focusOut(false)">
        @if (checkFormValidity() && form.get(fieldData.name).value != null && form.get(fieldData.name).value != '') {
          <p class="uk-form-danger uk-animation-fade uk-text-italic">
            @if (properties.decimals) {
              Value should be a number with up to {{ properties.decimals }} decimals separated with '.'
            } @else {
              Value should be a number{{ properties.decimals === 0 ? ' (no decimals)' : '' }}.
            }
          </p>
        }
      }
    </div>

  </app-base-field-html>
</ng-container>
